import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useLiveClasses } from "@/hooks/useComms";
import LoadingState from "../components/LoadingState";
import ErrorState from "../components/ErrorState";

export default function DersKayitlari() {
  const { data, loading, error, reload } = useLiveClasses();
  const [query, setQuery] = useState("");

  const recordings = useMemo(() => {
    const list = (data ?? []).filter(
      (c) => c.status === "ended" && (c.hasRecording || c.recordingUrl),
    );
    const q = query.trim().toLowerCase();
    if (!q) return list;
    return list.filter(
      (c) =>
        c.title.toLowerCase().includes(q) ||
        c.subject.toLowerCase().includes(q) ||
        c.teacher.toLowerCase().includes(q),
    );
  }, [data, query]);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} onRetry={reload} />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">Ders Kayıtları</h1>
        <p className="text-sm md:text-base text-foreground-600 mt-1">
          Kaçırdığın veya tekrar etmek istediğin canlı derslerin kayıtları (VOD).
        </p>
      </div>

      <div className="relative max-w-md">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" aria-hidden="true"></i>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Ders, konu veya öğretmen ara..."
          className="w-full h-10 pl-9 pr-3 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
        />
      </div>

      {recordings.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-50 p-12 flex flex-col items-center justify-center text-center">
          <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-video-on-line text-2xl" aria-hidden="true"></i>
          </span>
          <p className="mt-4 font-heading font-semibold text-base text-foreground-700">Kayıt bulunamadı</p>
          <p className="mt-1.5 text-sm text-foreground-500 max-w-md">
            {query ? "Aramanla eşleşen bir kayıt yok." : "Tamamlanmış canlı derslerin kayıtları burada listelenecek."}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {recordings.map((c) => (
            <Link
              key={c.id}
              to={`/ogrenci/canli-ders/${c.id}/kayit`}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="aspect-video bg-background-900 relative flex items-center justify-center">
                <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/60 text-background-100 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
                </span>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-200 text-xs font-medium whitespace-nowrap">
                  {c.duration} dk
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-950 leading-snug">{c.title}</h3>
                <p className="mt-1 text-sm text-foreground-500">{c.subject}{c.grade ? ` · ${c.grade}` : ""}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line" aria-hidden="true"></i>
                    {c.teacher}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true"></i>
                    {c.date}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}